import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from '../../utils/apiClient';

/* eslint-disable import/prefer-default-export */
export const useGenerateZeroReceipt = () => {
  const apiClient = useApiClient();
  const intl = useIntl();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClient.Rksv.postCustomReceipt,
    onSuccess: () => {
      message.success(
        intl.formatMessage({
          defaultMessage: 'Receipt generated successfully',
        })
      );
      queryClient.refetchQueries({ queryKey: ['rksv', 'receipts'] });
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};

export const useReceipts = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['rksv', 'receipts'],
    queryFn: apiClient.Rksv.getAllReceipts,
  });
};

export const useDownloadSingleReceipt = () => {
  const apiClient = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Rksv.downloadReceipt,
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};
